import { Input } from '@/components/shadcn/ui/input';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormTextFieldProps extends Omit<
  React.ComponentProps<typeof Input>,
  'value' | 'onChange' | 'name'
> {
  showErrorMessage?: boolean;
}

export function FormTextField({
  showErrorMessage = true,
  ...inputProps
}: FormTextFieldProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Input
        id={field.name}
        name={field.name}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        {...inputProps}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
